import { render, staticRenderFns } from "./bindPhone.vue?vue&type=template&id=fff3d92e&scoped=true&"
import script from "./bindPhone.vue?vue&type=script&lang=js&"
export * from "./bindPhone.vue?vue&type=script&lang=js&"
import style0 from "./bindPhone.vue?vue&type=style&index=0&id=fff3d92e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff3d92e",
  null
  
)

export default component.exports